export default __webpack_public_path__ + "static/media/downOxxo.2d460db0.svg";